var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPickupStrokeSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "M6.772 16.971c-2.41-2.547-3.022-4.028-3.022-6.747C3.75 5.406 7.443 1.5 12 1.5s8.25 3.906 8.25 8.724c0 2.717-.819 4.418-3.018 6.744L12.001 22.5l-5.229-5.529z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "M12 12.7c1.519 0 2.75-1.253 2.75-2.8 0-1.546-1.231-2.8-2.75-2.8S9.25 8.354 9.25 9.9c0 1.547 1.231 2.8 2.75 2.8z",
    clipRule: "evenodd"
  }));
}
export default SvgIconPickupStrokeSm;